// @flow
import {
  WIDGET_ID,
  WIDGET_MODAL,
  SPINNER_ID,
  SPINNER_WRAPPER_ID,
  MODAL,
  MODAL_OPEN,
  IFRAME_SOURCE_ID,
} from '../constants'

// Create a DOM element
const createElement = (elementName) => global.document.createElement(elementName)

// Close and destroy a DOM element
const removeElement = (el: Node) => {
  if (!el) throw new Error(`Failed to match: ${el}`)
  el.parentNode && el.parentNode.removeChild(el)
}

// Create Wrapper
const createWrapper = (el: Node): Node => {
  // iframe wrapper
  const iframeWrapper = createElement('div')
  iframeWrapper.id = WIDGET_MODAL
  iframeWrapper.classList.add(MODAL, MODAL_OPEN)
  el.appendChild(iframeWrapper)
  return iframeWrapper
}

// Create Spinner with a wrapper
const createSpinner = (el: Node) => {
  // spinner
  const spinner = createElement('div')
  spinner.id = SPINNER_ID

  // spinner wrapper
  const spinnerWrapper = createElement('div')
  spinnerWrapper.id = SPINNER_WRAPPER_ID
  spinnerWrapper.appendChild(spinner)
  el.appendChild(spinnerWrapper)
}

// Remove Spinner with a wrapper
const removeSpinner = () => {
  const spinnerWrapperElem = document.getElementById(SPINNER_WRAPPER_ID)
  spinnerWrapperElem && removeElement(spinnerWrapperElem)
}

// Create Iframe
const createIframe = (iframeWrapper: Node) => {
  // iframe
  const iframe = createElement('iframe')
  iframe.id = WIDGET_ID
  iframe.referrerPolicy = 'origin'
  iframe.src = process.env.IFRAME_SRC
  iframe.onload = removeSpinner
  iframe.onerror = removeSpinner
  iframeWrapper && iframeWrapper.appendChild(iframe)
}

// reload iframe
const reloadIframe = () => {
  const iframe: any = document.getElementById(WIDGET_ID)
  iframe && iframe.setAttribute('src', iframe.src)
}

// Remove Iframe with a wrapper
const clearSocket = () => {
  removeSpinner()
  const iframeWrapperElem = document.getElementById(WIDGET_MODAL)
  iframeWrapperElem && removeElement(iframeWrapperElem)
}

export { createIframe, createSpinner, createWrapper, clearSocket, removeSpinner, reloadIframe }
